import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'

export const PreviewSpan = (props: TextProps) => <Text fontSize="sm" {...props} />
